export enum LicenceModules {
  ALC = 1,
  BI = 2,
  Pressure = 3,
}
